import { UserNotification } from './user-notification-types';

export function getLastReadNotificationId(): number | null {
    return JSON.parse(localStorage.getItem('lastReadNotificationId'));
}

export function setLastReadNotificationId(notificationId: number): void {
    if (notificationId) {
        localStorage.setItem(
            'lastReadNotificationId',
            notificationId.toString()
        );
    }
}

export function markUnreadNotifications(
    notifications: UserNotification[],
    currentPage: number,
    pageSize: number
): UserNotification[] {
    const lastReadId = getLastReadNotificationId();

    if (lastReadId === null && notifications.length > 0 && currentPage === 1) {
        setLastReadNotificationId(notifications[0].id);
        return notifications.map((n) => ({ ...n, read: true }));
    }

    return notifications.map((n) => ({
        ...n,
        read: lastReadId !== null ? n.id <= lastReadId : true,
    }));
}
